import { Link as RouterLink } from 'react-router-dom';
import { clsx } from 'clsx';
import agrantisLogo2 from '@/assets/logo-2.svg?url';
import agrantisLogo from '@/assets/logo.svg?url';

interface LogoProps {
  disabledLink?: boolean;
  className?: string;
  type?: 1 | 2;
}

const Logo = (props: LogoProps) => {
  const { disabledLink = false, className, type = 1 } = props;

  const logo = (
    <div
      className={clsx(
        className,
        type === 2 ? '' : 'w-22-0 h-10-0 md:w-16-0 flex',
      )}
    >
      <img src={type === 1 ? agrantisLogo : agrantisLogo2} />
    </div>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
};

export default Logo;
